import { ONE, ZERO } from '@/constants';

export const capitalize = (string: string) =>
  string.length
    ? (string[ZERO] as string).toUpperCase() + string.slice(ONE)
    : '';
